<mat-card appearance="outlined" class="Card p-0 flex flex-col overflow-hidden" [ngClass]="cardClasses">
  <h3 class="mat-headline-6 p-3 mb-0" *ngIf="!cardHeader?.template && title">{{ title }}</h3>
  <ng-container *ngIf="cardHeader?.template" [ngTemplateOutlet]="cardHeader.template"></ng-container>
  <div [ngClass]="contentClasses" class="flex flex-col">
    <ng-content></ng-content>
  </div>
</mat-card>
